module.exports = __webpack_public_path__ + "img/icon-service-system-5.96d2ca89.svg";